import { render, staticRenderFns } from "./TextareaField.vue?vue&type=template&id=2a9b2212&lang=pug&"
import script from "./TextareaField.vue?vue&type=script&lang=js&"
export * from "./TextareaField.vue?vue&type=script&lang=js&"
import style0 from "./TextareaField.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a9b2212')) {
      api.createRecord('2a9b2212', component.options)
    } else {
      api.reload('2a9b2212', component.options)
    }
    module.hot.accept("./TextareaField.vue?vue&type=template&id=2a9b2212&lang=pug&", function () {
      api.rerender('2a9b2212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/TextareaField.vue"
export default component.exports